module.exports = __webpack_public_path__ + "img/Dots.87a0f360.png";